module.exports = __webpack_public_path__ + "img/block-v-1-m.33125151.jpg";